/**
 * Viral Gallery — types shared between page, grid, card, and detail modal.
 */

export type GalleryMediaType = "image" | "video";

export const GALLERY_CATEGORIES = [
  "ads_ecommerce",
  "ads_lead_generation",
  "video_talking_head",
  "video_ugc_ecommerce",
  "video_ugc_software",
  "ads_graphic_ai",
  "social_graphic",
  "social_organic",
] as const;

export type GalleryCategory = (typeof GALLERY_CATEGORIES)[number];

export const GALLERY_CATEGORY_LABEL_KEYS: Record<
  GalleryCategory,
  `viralGallery.categories.${GalleryCategory}`
> = {
  ads_ecommerce: "viralGallery.categories.ads_ecommerce",
  ads_lead_generation: "viralGallery.categories.ads_lead_generation",
  video_talking_head: "viralGallery.categories.video_talking_head",
  video_ugc_ecommerce: "viralGallery.categories.video_ugc_ecommerce",
  video_ugc_software: "viralGallery.categories.video_ugc_software",
  ads_graphic_ai: "viralGallery.categories.ads_graphic_ai",
  social_graphic: "viralGallery.categories.social_graphic",
  social_organic: "viralGallery.categories.social_organic",
};

export const GALLERY_MEDIA_TYPES = ["all", "image", "video"] as const;
export type GalleryMediaTypeFilter = (typeof GALLERY_MEDIA_TYPES)[number];

export interface GalleryItem {
  id: string;
  userId: string;
  r2Key: string;
  filename: string;
  format: string;
  width: number;
  height: number;
  fileSizeBytes: number;
  prompt: string | null;
  imageModel: string | null;
  mediaType: GalleryMediaType | null;
  rating: string | null;
  isFeatured: boolean | null;
  isPublic: boolean | null;
  isInGallery: boolean | null;
  galleryCategory: GalleryCategory | null;
  parentGraphicId: string | null;
  createdAt: string | null;
  signedUrl: string | null;
  isOwn: boolean;
  authorName: string | null;
  creatorType: string | null;
  creatorSettings: Record<string, unknown> | null;
}

export interface GalleryListResponse {
  items: GalleryItem[];
  total: number;
  page: number;
  pageSize: number;
}
